import React from 'react';
import { ORDER_TYPES } from '../helpers/orderType';

/**
 * Three-state order-type filter ("All" | "KIND / CGI" | "Copywrite") rendered as a flat
 * segmented control. `value` is 'all' | 'kind' | 'copywrite'.
 *
 * Replaces the old KIND on/off toggle on the booking overviews, which could only tell
 * KIND orders apart from everything else.
 */
export const ORDER_TYPE_FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: ORDER_TYPES.KIND, label: 'KIND / CGI' },
  { value: ORDER_TYPES.COPYWRITE, label: 'Copywrite' },
];

const OrderTypeFilter = ({ value = 'all', onChange, style }) => (
  <div role="group" aria-label="Order type" style={{ display: 'inline-flex', ...style }}>
    {ORDER_TYPE_FILTER_OPTIONS.map((option) => {
      const active = value === option.value;
      return (
        <button
          key={option.value}
          type="button"
          aria-pressed={active}
          onClick={() => onChange && onChange(option.value)}
          style={{
            padding: '8px 14px',
            fontSize: '13px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.02em',
            cursor: 'pointer',
            border: '1px solid #000',
            marginLeft: '-1px',
            backgroundColor: active ? '#000' : '#fff',
            color: active ? '#fff' : '#000',
          }}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default OrderTypeFilter;
